// フォームクリア
import commonClass from "./commonClass";

export default class frmClearClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._$prt = $('.js-frmclr');

    this._changeDisablePrt = '.js-frm_disable_prt';
    this._changeDisableTrg = '.js-frm_disable_trg';
    this._changeDisableTgt = '.js-frm_disable_tgt';
    this._changeCurrentTgt = '.js-frm_current_tgt';
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;

    // 空チェック処理初期化
    cls._checkEmpty();

    // クリア処理初期化
    cls._clear();

    // ディセブルON/OFF処理
    cls._changeDisable();

    // カレント表示
    cls._changeRadioCurrent();
  }

  // 空チェック
  _checkEmpty() {
    var cls = this;
    // 対象のinput、textarea要素取得
    var tgtSelector = '.c-frm_itm input[type="text"], .c-frm_itm input[type="number"], .c-frm_itm input[type="password"], .c-frm_textarea textarea, .c-frm_select select';

    $(tgtSelector).each(function(index, el) {
      doCheck($(el));
    });

    $(document).on('change blur', tgtSelector, function() {
      doCheck($(this));
    });

    function doCheck($tgt) {
      var val = $tgt.val() && $tgt.val().replace(/\s/g, '');

      if (val !== '') {
        $tgt.addClass('has-val');
      } else {
        $tgt.removeClass('has-val');
        $tgt.val(val);
      }
    }
  }

  // クリア処理
  _clear() {
    var cls = this;

    this._$prt.each(function (idx, elm) {
      var $prt = $(elm);
      var $trg = $prt.find('.js-frmclr_trg');

      var $ipt;
      var $chkbox;
      var $radio;
      var $txtarea;
      var $slctopt;
      var $nbr;

      $trg.on('click', function(e) {
        if (e.clientX === 0 && e.clientY === 0) {
          return;
        }
        // 動的に追加されているipt要素もあるためここで取得
        $ipt = $prt.find('input[type="text"]');
        $chkbox = $prt.find('input[type="checkbox"]');
        $radio = $prt.find('input[type="radio"]');
        $txtarea = $prt.find('textarea');
        $slctopt = $prt.find('option');
        $nbr = $prt.find('input[type="number"]');

        // 各ipt要素の値をリセット
        // 増減セレクタはVariableSelectClassから初期化処理を実行
        APP.VariableSelect._reinit($(this));
        $ipt.removeClass('has-val').val('');
        $chkbox.prop('checked', false).trigger('change');
        $radio.prop('checked', false).trigger('change');
        $txtarea.removeClass('has-val').val('');
        $slctopt.prop('selected', false).trigger('change');
        $nbr.removeClass('has-val').val('');
        $('.field-validation-error').html('');
        return false;
      });
    });
  }

  // ディセブルON/OFF処理
  _changeDisable() {
    var cls = this;
    var $tgt;

    $(document).on('change', cls._changeDisableTrg, function() {
      var $this = $(this);
      $tgt = $this.closest(cls._changeDisablePrt).find(cls._changeDisableTgt);

      if ($this.attr('type') === 'radio') {
        // ラジオボタンの場合は、'is-disable_trg'クラスのラジオを選択した場合のみ非活性にする
        var isDisableTrg = $this.hasClass('is-disable_trg') && $this.prop('checked');
        $tgt.prop('disabled', isDisableTrg);
      } else if ($this.attr('type') === 'text') {
        console.log($this.hasClass('has-val'))
        if ($this.hasClass('has-val')) {
          $tgt.prop('disabled', false);
        } else {
          $tgt.prop('disabled', true);
        }
      } else {
        if ($this.prop('checked')) {
          $tgt.prop('disabled', false);
        } else {
          $tgt.prop('disabled', true);
        }
      }

      return false;
    });
  }

  // カレント表示
  _changeRadioCurrent() {
    var cls = this;

    $(document).on('change', cls._changeCurrentTgt, function() {
      var $this = $(this);

      $this.siblings('div').removeClass('is-current');
      $this.addClass('is-current');
      return false;
    });
  }
}